import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import {
  ICategory,
  IPaginatedResponse,
} from '@boma/administration-portal/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private base: string;
  private version: string;
  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listCategories(
    page: string = '1',
    parentId: string = null,
    perPage: string = '150'
  ) {
    const params = {
      page,
      perPage,
    };

    if (parentId != null) {
      params['parentId'] = parentId;
    }

    return this.httpClient.get<ICategory[]>(
      `${this.base}api/v${this.version}/Categories`,
      {
        params,
      }
    );
  }

  getCategoryDetails(id: string) {
    return this.httpClient.get<ICategory>(
      `${this.base}api/v${this.version}/Categories/${id}`
    );
  }

  createCategory(category: any) {
    return this.httpClient.post<ICategory>(
      `${this.base}api/v${this.version}/Categories`,
      {
        ...category,
      }
    );
  }

  updateCategory(category: any, categoryId: string) {
    return this.httpClient.put<ICategory>(
      `${this.base}api/v${this.version}/Categories/${categoryId}`,
      {
        ...category,
      }
    );
  }

  deleteCategory(categoryId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Categories/${categoryId}`
    );
  }
}
